import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import './StrategyEditor.css'
import Modal from 'react-responsive-modal'
import i18n from './../../../i18n'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import InputBox from '../InputBox/InputBox.js'
import HoldingsEditor from '../HoldingsEditor/HoldingsEditor.js'

class StrategyEditor extends PureComponent {
  static defaultProps = {
    strategyToEdit: null,
    saveNewStrategy: null,
    closeEditor: null,
    showEditor: false,
    updateStategyDetails: null,
    params: null,
    typeaheadUrl: null,
    checkTickersUrl: null,
    benchmarks: []
  }

  constructor(props) {
    super(props)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleNameEdit = this.handleNameEdit.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleUpdateHoldings = this.handleUpdateHoldings.bind(this)
    this.handleSelectBenchmarks = this.handleSelectBenchmarks.bind(this)

    const strategyToEdit = props.strategyToEdit

    const selectedBenchmark =
      strategyToEdit && strategyToEdit.latestAnalysis && strategyToEdit.latestAnalysis.benchmarks
        ? {
            label: strategyToEdit.latestAnalysis.benchmarks[strategyToEdit.latestAnalysis.benchmarks.length - 1].name,
            value: strategyToEdit.latestAnalysis.benchmarks[strategyToEdit.latestAnalysis.benchmarks.length - 1].externalID
          }
        : null

    // Set up local state
    this.state = {
      name: strategyToEdit ? strategyToEdit.name : i18n.t('new-strategy'),
      dirty: false,
      updatedHoldings: null,
      selectedBenchmark: selectedBenchmark,
      rerunAnalysis: false
    }
  }

  // Handle close of modal
  handleCloseModal() {
    this.clearFields()
    this.props.closeEditor()
  }

  // Handle save of the edits
  handleSave() {
    const { strategyToEdit } = this.props

    // Don't do anything if nothing has changed
    if (!this.state.dirty) {
      return
    }

    this.setState({
      dirty: false
    })

    let formattedHoldings = null

    // Get the original totalValue if it exists
    let totalValue = strategyToEdit ? strategyToEdit.totalValue : 1000000

    if (this.state.updatedHoldings) {
      // Create holdings object in format for API (Stacks the arrays together)
      formattedHoldings = [
        {
          tickers: this.state.updatedHoldings.map(holding => {
            return holding.ticker
          }),
          weights: this.state.updatedHoldings.map(holding => {
            return holding.weight
          })
        }
      ]

      // Get the Total Value of the portfolio - defaults to 1000000
      let amounts = this.state.updatedHoldings.map(holding => {
        return holding.amount
      })

      // Total up the amounts
      totalValue = amounts.reduce(function sumofArray(sum, num) {
        return sum + num
      })

      // IF other fields require a re-analysis (e.g., benchmark has changed)
      // then force the addition of holdings again
    } else if (this.state.rerunAnalysis && strategyToEdit.holdings[strategyToEdit.holdings.length - 1]) {
      // Create holdings object in format for API (Stacks the arrays together)
      formattedHoldings = [
        {
          tickers: strategyToEdit.holdings[strategyToEdit.holdings.length - 1].tickers,
          weights: strategyToEdit.holdings[strategyToEdit.holdings.length - 1].weights
        }
      ]
    }

    // Create dict of all fields that need updating
    const fieldsToUpdate = {
      id: this.props.strategyToEdit ? this.props.strategyToEdit.id : null,
      name: this.state.name ? this.state.name : this.props.strategyToEdit.name,
      holdings: formattedHoldings,
      benchmarkExternalID: this.state.selectedBenchmark && this.state.selectedBenchmark.value ? this.state.selectedBenchmark.value : null,
      totalValue: totalValue
    }

    // If a strategy exists then update it
    if (this.props.strategyToEdit) {
      this.props.updateStategyDetails(fieldsToUpdate)
      // Otherwise save a new one
    } else {
      this.props.saveNewStrategy(fieldsToUpdate)
    }

    // Clear all the input fields
    this.clearFields()

    // Close the editor window
    this.props.closeEditor()
  }

  clearFields() {
    this.setState({
      name: i18n.t('new-strategy'),
      dirty: false,
      updatedHoldings: null,
      rerunAnalysis: false
    })
  }

  handleNameEdit(value) {
    this.setState({
      name: value,
      dirty: true
    })
  }

  handleUpdateHoldings(holdings) {
    this.setState({
      updatedHoldings: holdings,
      dirty: true,
      rerunAnalysis: true
    })
  }

  // Select the benchmark
  handleSelectBenchmarks(benchmark) {
    // Update local state
    this.setState({
      selectedBenchmark: benchmark,
      dirty: true,
      rerunAnalysis: true
    })
  }

  render() {
    const { showEditor, strategyToEdit, params, typeaheadUrl, checkTickersUrl } = this.props

    const initialHoldings = strategyToEdit ? strategyToEdit.holdings[strategyToEdit.holdings.length - 1] : null
    const totalValue = strategyToEdit ? strategyToEdit.totalValue : 1000000
    let benchmarkOptions = this.props.benchmarks
      .filter(benchmark => !this.state.selectedBenchmark || benchmark.externalID !== this.state.selectedBenchmark.value)
      .map(benchmark => {
        return {
          label: benchmark.name,
          value: benchmark.externalID,
          className: 'wt-dropdown-option'
        }
      })

    // Add 'None' as an option if there is already a benchmark
    benchmarkOptions = this.state.selectedBenchmark
      ? [
          {
            label: 'None',
            value: null,
            className: 'wt-dropdown-option'
          }
        ].concat(benchmarkOptions)
      : benchmarkOptions

    return showEditor ? (
      <div>
        <Modal
          open={showEditor === true}
          onClose={this.handleCloseModal}
          showCloseIcon={false}
          classNames={{ overlay: 'modal-overlay', modal: 'strategy-hub-editor' }}
          closeOnOverlayClick={false} // Stops user from closing when clicking off modal
          closeOnEsc={false}
          center
        >
          <div className='strategy-hub-editor-container'>
            <div className='inputs'>
              {/* Draw the Personal Strategy name edit box */}
              <InputBox value={this.state.name} onChange={this.handleNameEdit} onBlur={undefined} editLabel={i18n.t('edit-name')} />
              {/* <div className='periodicity'>
                <Dropdown controlClassName='wt-dropdown-periodicity' arrowClassName='wt-dropdown-arrow' menuClassName='wt-dropdown' options={periodicityOptions} placeholder={i18n.t('select-a-periodicity')} onChange={this.handleSelectPeriodicity} value={this.state.periodicity} />
              </div> */}
              {/* Show the editor for holdings (includes the typeahead component) */}
              <HoldingsEditor initialHoldings={initialHoldings} params={params} typeaheadUrl={typeaheadUrl} checkTickersUrl={checkTickersUrl} updateHoldings={this.handleUpdateHoldings} benchmarks={this.props.benchmarks} totalValue={totalValue} />

              <div className='other-inputs'>
                {/* Add the benchmarks */}
                {this.props.benchmarks.length > 0 ? (
                  <div className='benchmarks'>
                    <Dropdown controlClassName='wt-dropdown' arrowClassName='wt-dropdown-arrow' menuClassName='wt-dropdown' options={benchmarkOptions} placeholder={i18n.t('select-a-benchmark')} onChange={this.handleSelectBenchmarks} value={this.state.selectedBenchmark} />
                  </div>
                ) : null}
              </div>
            </div>

            <div className='action-buttons-hub'>
              <span className='strategy-editor-footnote'>{i18n.t('strategy-editor-footnote')}</span>
              <button
                onClick={this.handleSave}
                // Make sure the Save button is disable if the page is not dirty or doesn't have any new holdings
                disabled={!(this.state.dirty && (this.state.updatedHoldings || initialHoldings))}
              >
                {i18n.t('save')}
              </button>
              <button onClick={this.handleCloseModal}>{i18n.t('cancel')}</button>
            </div>
          </div>
        </Modal>
      </div>
    ) : null
  }
}

export default connect(null, {})(StrategyEditor)
